import React, { Component } from 'react';
import DialogInput from '../advanced/DialogInput';
import Button from './Button';
import DialogHeaderWithClose from './DialogHeaderWithClose';

class ConfirmPOSOrderImportDialog extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
           <div> {!this.props.result && <div>
            <DialogInput
                // title="Confirm POS Order Upload"
                title={<DialogHeaderWithClose text="Confirm POS Order Upload" classicClass="posDialogClassic" handleClose={() => this.props.closeDialog()} />}
                actions={[
                    <Button
                        key={3}
                        name="CancelButton"
                        className="mr-1"
                        backgroundColor="Grey"
                        label="CANCEL"
                        primary={true}
                        onTouchTap={() => this.props.closeDialog()} />,
                    <Button
                        key={2}
                        name="ConfirmButton"
                        label="Proceed"
                        primary={true}
                        onTouchTap={() => this.props.startImport()} />]}
                modal={true}
                handleClose={() => this.props.closeDialog()}
                open={this.props.confirmDialog}>
                <br />
                <div>{this.props.branchName ? <p>The branch these products is being added to is: <b>{this.props.branchName}</b>----<b>{this.props.deviceId}</b></p> : ''}
                    <br />
                    {this.props.model && <p>The Product SKU in this file are:</p>}
                    <ul style={{ maxHeight: `300px`, overflowY: `auto`, listStyleType: `circle` }}>
                        {this.props.model && this.props.model.Products && this.props.model.Products.map(item => item.SKU && item.Quantity ? <li>{item.SKU} - {item.Quantity} Units</li> : <li>-</li>)}
                    </ul>
                    {this.props.model && this.props.model.Products && <p><b><br />There are {this.props.model.Products.length} products in this file.</b></p>}
                    <br />
                    {this.props.model && <p>Do you want to proceed adding these products?</p>}</div>
            </DialogInput>
            </div>
           }{
            this.props.result && <div>
            <DialogInput
            // title="Result of Import"
            title={<DialogHeaderWithClose text="Result of Import" classicClass="posDialogClassic" handleClose={() => this.props.closeDialog()} />}
            modal={true}
            handleClose={() => this.props.closeDialog()}
            open={this.props.confirmDialog}>
            <ul style={{ maxHeight: `300px`, overflowY: `auto`, listStyleType: `circle` }}>
                        {this.props.result && this.props.result.map(item => item ? <li>{item}</li> : <li>-</li>)}
            </ul>
            </DialogInput>
            </div>
            }

            </div>
        );
    }
}

export default (ConfirmPOSOrderImportDialog);
